import { action, extendObservable } from 'mobx';
import { englishLevelCourses } from '../../../core/consts';
import FetchService from '../../../core/services/FetchService';
import placementTestReportFilterService from './PlacementTestReportFilterService';

class AverageLevelChartService {
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      course: null,
    });
  }

  load = action(() => {
    this.fetch
      .fetch({
        url: '/placement-test-report/average-reached-level',
        query: {
          ...placementTestReportFilterService.form.getValues(),
          ...(placementTestReportFilterService.form.getValue('periodStart') &&
            placementTestReportFilterService.form.getValue('periodEnd') && {
              periodStart: placementTestReportFilterService.form.getValue('periodStart').format('YYYY-MM-DD'),
              periodEnd: placementTestReportFilterService.form.getValue('periodEnd').format('YYYY-MM-DD'),
            }),
        },
      })
      .then(() => {
        if (this.fetch.data && this.fetch.data.length > 0) {
          let course = null;

          englishLevelCourses
            .slice()
            .reverse()
            .reduce((acc, levelCourse) => {
              if (this.fetch.data[0].averageLevel < 0.5) {
                course = 'Beginner';
              } else if (levelCourse.value >= this.fetch.data[0].averageLevel) {
                course = levelCourse.label;
              }
              return acc;
            }, {});

          this.course = course;
        } else {
          this.course = null;
        }
      });
  });
}

const averageLevelChartService = new AverageLevelChartService();
export default averageLevelChartService;
